import { clsx } from "clsx"
import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { Check } from "src/icons"
import "./style.scss"

interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
}
const Chip = ({ title, ...props }: ChipProps) => {
  return (
    <div {...props} className={clsx("hero-chip", props.className)}>
      <Check />
      <span>{title}</span>
    </div>
  )
}

export const HeroPhone = () => {
  return (
    <div className="hero-phone">
      <Container>
        <Image src="iban/hero-phone.png" className="hero-phone-img" />
        <div className="hero-phone-chips">
          <Chip title="SEPA and SWIFT support" />
          <Chip title="Get your own IBAN" />
          <Chip title="Instant payout to card (any bank)" />
          <Chip title="Buy and Sell crypto" />
          <Chip title="Trade 24/7 instantly" />
          <Chip title="Order virtual and physical crypto cards" />
          <Chip title="Cash out at the ATM" />
        </div>
      </Container>
    </div>
  )
}
